import React from 'react';

import { TallButton } from 'ui/component';
import { StyleUtil } from 'ui/util';
import { useEricssonGTM } from '../../hook';
import { DetailCircle, DetailCircleProgress } from '../detail-circle/DetailCircle.component';
import classNames from './EABDDetailCircleWithButtons.module.scss';

export const DetailCircleWithButtons = React.memo(() => {
  const ericssonGTM = useEricssonGTM();
  const [progress, setProgress] = React.useState<DetailCircleProgress>('bottomLeft');

  const onAccessToDataButtonPressCallback = React.useCallback(() => {
    setProgress('top');
    ericssonGTM.onKeyToSuccessCategoryClick('Access to data');
  }, [ericssonGTM]);
  const onGlobalOperationsButtonPressCallback = React.useCallback(() => {
    setProgress('bottomLeft');
    ericssonGTM.onKeyToSuccessCategoryClick('Global operation');
  }, [ericssonGTM]);
  const onCompetenceAndInnovationButtonPressCallback = React.useCallback(() => {
    setProgress('bottomRight');
    ericssonGTM.onKeyToSuccessCategoryClick('Competence & innovation');
  }, [ericssonGTM]);

  const AccessToDataButtonElement = React.useMemo(() => {
    return (
      <TallButton type={'tertiary'} isFilled={progress === 'top'} onPress={onAccessToDataButtonPressCallback}>
        {'Access to data'}
      </TallButton>
    );
  }, [progress, onAccessToDataButtonPressCallback]);

  const GlolbalOperationsButtonElement = React.useMemo(() => {
    return (
      <TallButton type={'secondary'} isFilled={progress === 'bottomLeft'} onPress={onGlobalOperationsButtonPressCallback}>
        Global
        <br />
        operations
      </TallButton>
    );
  }, [progress, onGlobalOperationsButtonPressCallback]);

  const CompetenceAndInnovationButtonElement = React.useMemo(() => {
    return (
      <TallButton type={'quaternary'} isFilled={progress === 'bottomRight'} onPress={onCompetenceAndInnovationButtonPressCallback}>
        {'Competence'}
        <br />
        {'& innovation'}
      </TallButton>
    );
  }, [progress, onCompetenceAndInnovationButtonPressCallback]);

  const TopButtonContainerElement = React.useMemo(() => {
    const accessToDataLineClassNames: string[] = [classNames.topLine];

    switch (progress) {
      case 'top':
        accessToDataLineClassNames.push(classNames.active);
        break;
    }

    return (
      <div className={classNames.topButtonContainer}>
        {AccessToDataButtonElement}
        <div className={classNames.verticalLineWrapper}>
          <div className={StyleUtil.mergeClassNames(accessToDataLineClassNames)} />
        </div>
      </div>
    );
  }, [progress, AccessToDataButtonElement]);

  const BottomButtonsContainerElement = React.useMemo(() => {
    return (
      <div className={classNames.bottomButtonContainer}>
        {GlolbalOperationsButtonElement}
        {CompetenceAndInnovationButtonElement}
      </div>
    );
  }, [GlolbalOperationsButtonElement, CompetenceAndInnovationButtonElement]);

  const CircleContainerElement = React.useMemo(() => {
    const globalOperationsLineClassNames: string[] = [classNames.bottomLeftLine];
    const competenceAndInnovationLineClassNames: string[] = [classNames.bottomRightLine];

    switch (progress) {
      case 'bottomLeft':
        globalOperationsLineClassNames.push(classNames.active);
        break;
      case 'bottomRight':
        competenceAndInnovationLineClassNames.push(classNames.active);
        break;
    }

    return (
      <div className={classNames.circleContainer}>
        <div className={classNames.desktopButtonContainer}>
          {GlolbalOperationsButtonElement}
          <div className={classNames.horizontalLineWrapper}>
            <div className={StyleUtil.mergeClassNames(globalOperationsLineClassNames)} />
          </div>
        </div>
        <DetailCircle progress={progress} />
        <div className={classNames.desktopButtonContainer}>
          <div className={classNames.horizontalLineWrapper}>
            <div className={StyleUtil.mergeClassNames(competenceAndInnovationLineClassNames)} />
          </div>
          {CompetenceAndInnovationButtonElement}
        </div>
      </div>
    );
  }, [progress, GlolbalOperationsButtonElement, CompetenceAndInnovationButtonElement]);

  return (
    <div className={classNames.container}>
      {TopButtonContainerElement}
      {CircleContainerElement}
      {BottomButtonsContainerElement}
    </div>
  );
});
